import { componentStyle } from '@/styling/util/component-style.ts';

export const chipStyle = componentStyle({
    paddingY: '0.25rem',
});
